export const BUSINESS_TRIP_SOLID_FALLBACK = 'rgb(88, 165, 175)';
export const MILITARY_SERVICE_SOLID_FALLBACK = 'rgba(85, 107, 47, 0.9)';
export const PRAKTIKA_SOLID_FALLBACK = 'rgba(147, 112, 219, 0.88)';

export const STATUS_COLORS: Record<string, string> = {
  working: 'rgba(255, 193, 112, 0.85)',
  day_off: 'rgba(70, 150, 70, 0.85)',
  mothers_day: 'rgba(173, 216, 230, 0.85)',
  remote: 'rgba(255, 250, 205, 0.85)',
  sick_leave: 'rgba(152, 251, 152, 0.85)',
  rest_day: 'rgba(200, 170, 200, 0.85)',
  state_holiday: 'rgba(255, 182, 193, 0.85)',
  business_trip: BUSINESS_TRIP_SOLID_FALLBACK,
  military_service: MILITARY_SERVICE_SOLID_FALLBACK,
  praktika: PRAKTIKA_SOLID_FALLBACK,
};

export function getStatusColor(status: string): string {
  return STATUS_COLORS[status] ?? '#f5f5f5';
}

export function getStatusAbbreviation(status: string): string {
  switch (status) {
    case 'working':
      return 'D';
    case 'remote':
      return 'N';
    case 'sick_leave':
      return 'L';
    case 'day_off':
      return 'A';
    case 'mothers_day':
      return 'M';
    case 'rest_day':
      return 'P';
    case 'state_holiday':
      return 'Š';
    case 'business_trip':
      return 'K';
    case 'military_service':
      return 'KT';
    case 'praktika':
      return 'Pr';
    default:
      return '';
  }
}

/** Truncate HH:MM:SS to HH:MM for compact display. */
export function formatTimeShort(time?: string): string {
  if (!time) return '';
  return time.length >= 5 ? time.slice(0, 5) : time;
}

export function formatScheduleTimes(start?: string, end?: string): string {
  const s = formatTimeShort(start);
  const e = formatTimeShort(end);
  if (!s || !e) return '';
  return `${s}–${e}`;
}
